// Estimated storybook generation time by page count, shown to users while waiting.
// 8 pages → 2–3 min, 25 → 4–6 min, 50 → 7–9 min (thresholds handle any value).
export const getGenerationEstimate = (pageCount) => {
  const pages = Number(pageCount) || 0;
  if (pages >= 50) return "7–9 minutes";
  if (pages >= 25) return "4–6 minutes";
  return "2–3 minutes";
};
